module.exports = __webpack_public_path__ + "img/empty.9988936.png";